import React, { useState, useEffect } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [text, setText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const fullText = "Farmnet is an amazing app—it automatically generates reports for you, making farm management so much easier.";

  useEffect(() => {
    let currentIndex = 0;
    let typingInterval;

    const typeText = () => {
      if (currentIndex < fullText.length) {
        setText(fullText.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        // Pause at the end before starting over
        clearInterval(typingInterval);
        setTimeout(() => {
          setIsTyping(false);
          setTimeout(() => {
            backspaceText();
          }, 2000);
        }, 1000);
      }
    };

    const backspaceText = () => {
      let backspaceInterval;
      let backspaceIndex = fullText.length;

      const eraseText = () => {
        if (backspaceIndex >= 0) {
          setText(fullText.substring(0, backspaceIndex));
          backspaceIndex--;
        } else {
          clearInterval(backspaceInterval);
          setIsTyping(true);
          currentIndex = 0;
          typingInterval = setInterval(typeText, 50); // Start typing again
        }
      };

      backspaceInterval = setInterval(eraseText, 20);
    };

    if (isTyping) {
      typingInterval = setInterval(typeText, 50);
    }

    return () => {
      clearInterval(typingInterval);
    };
  }, [isTyping, fullText]);

  return (
    <div className="relative bg-[#F3F3F3]">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center p mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3 ">
          <span className='text-[#152C24]'>     INSIGHTS & INNOVATIONS  </span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-2 border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Records Section */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2 md:mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[180px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
              <>
                <img
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751381745/image_9_dxvtm3.png"
                  alt="Mobile"
                  className="object-cover w-full h-full"
                />
              </>
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2 space-y-6'>
        <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3 text-[#979797]">
          INSIGHTS & INNOVATIONS |     <span className='text-[#152C24]'> Digital Agronomic services</span>
          </h1>
          <h1 className="text-[12px] md:text-[36px] font-normal text-black md:mb-3">
            Digital agronomic services use technology like mobile apps, sensors, and data platforms to provide farmers with accurate, timely, and customized agricultural advice. These services help improve farm productivity, reduce losses, and support informed decision-making by offering:
          </h1>

          <div className="space-y-2 sm:space-y-1">
            <ul className="md:text-[32px] text-[8px] list-disc list-inside pl-3 font-bold">
              <li className="font-bold">Weather forecasts and alerts</li>
              <li className="font-bold">Soil health insights and crop recommendations</li>
              <li className="font-bold">Pest and disease warnings</li>
              <li className="font-bold">Fertilizer and irrigation advice</li>
              <li className="font-bold">Best practices for planting, harvesting, and storage</li>
              <li className="font-bold">Remote farm monitoring using satellite or drone data</li>
            </ul>
          </div>
          
          <h2 className="text-[12px] md:text-[36px] font-bold text-[#152C24] md:mb-3">
            How the Farmnet App Provides Digital Agronomic Services:
          </h2>
          
          <p className="md:text-[32px] text-[8px]">
            The Farmnet App is designed to connect farmers with essential digital tools and expert support to boost farm productivity and profitability. Here's how it delivers digital agronomic services:
          </p>
          
          <ol className="md:text-[32px] text-[8px] list-decimal pl-8 space-y-2 [&>li::marker]:font-bold">
  <li><span className="font-bold">Personalized Crop Advisory:</span> Based on the farmer's location, soil type, and crop, Farmnet offers customized recommendations for planting, fertilization, pest control, and harvesting.</li>
  <li><span className="font-bold">Weather Forecasts & Alerts:</span> Farmers receive timely weather updates to help them plan field activities like planting, spraying, or harvesting.</li>
  <li><span className="font-bold">Pest & Disease Management:</span> The app alerts farmers to potential pest outbreaks and diseases in their area, along with treatment advice and prevention tips.</li>
  <li><span className="font-bold">Soil Health Monitoring:</span> Through digital records or integrated soil testing data, farmers get insights into soil fertility and receive fertilizer plans tailored to their needs.</li>
  <li><span className="font-bold">Market-Linked Advice:</span> Farmnet goes beyond production—linking agronomic guidance with market demand to help farmers grow what sells best.</li>
  <li><span className="font-bold">Learning Resources & Training:</span> Access videos, articles, and expert tips on good agricultural practices, sustainable farming, and new technologies—all within the app.</li>
</ol>
          
          <p className="md:text-[32px] text-[8px] md:mt-8 mt-3">
            Farmnet transforms traditional farming by offering real-time, digital agronomic services that empower farmers to make better decisions, increase yields, and connect to markets and partners.
          </p>
        </div>
            <div className='flex justify-end items-center'>
          <div>
            <h1 className="text-[18px] md:text-[32px] font-bold mt-2 mb-4 text-black">
              Download App
            </h1>
            <div className="md:w-[450px]">
              <div className="flex flex-row justify-between space-x-2 items-center sm:space-y-0">
                <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">   
             <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />    
             <p className="md:text-[14px] text-[6px] md:-mt-12 md:pl-5 font-normal md:px-1">
             Click to download App
  </p>
     </a>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
                  alt="Google Play"
                  className="h-[30px] md:h-[75px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;